import { Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import MarketingSite from "./pages/MarketingSite";
import LoginPage from "./pages/LoginPage";
import DashboardLayout from "./pages/dashboard/DashboardLayout";
import ClientList from "./pages/dashboard/ClientList";
import ClientDetail from "./pages/dashboard/ClientDetail";
import AIDashboard from "./pages/dashboard/AIDashboard";
import AICompanion from "./pages/dashboard/AICompanion";
import "@/App.css";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center"><div className="w-8 h-8 border-2 border-[#C9A84C] border-t-transparent rounded-full animate-spin"></div></div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <Toaster position="top-right" richColors />
      <Routes>
        <Route path="/" element={<MarketingSite />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/dashboard" element={<ProtectedRoute><DashboardLayout /></ProtectedRoute>}>
          <Route index element={<ClientList />} />
          <Route path="client/:clientId" element={<ClientDetail />} />
          <Route path="client/:clientId/ai-dashboard" element={<AIDashboard />} />
          <Route path="client/:clientId/ai-companion" element={<AICompanion />} />
        </Route>
      </Routes>
    </AuthProvider>
  );
}

export default App;
